import { useMemo } from "react";

import AdditionalItemsContainer from "@components/store/product-detail/shared/additional-items-container/";

import styles from "./main.module.scss";

const KitAdditionalItemsWidget = ({ intent, productData }) => {
  const product = useMemo(() => productData?.product, [productData]);

  if (!product) return null;

  return (
    <div className={styles.fullwidthBg}>
      <AdditionalItemsContainer product={product} intent={intent} />
    </div>
  );
};

export default KitAdditionalItemsWidget;
